var map = {
	"./Schneider Placement.webp": 24957,
	"./adwik.webp": 73677,
	"./bahwancybertec.webp": 26113,
	"./calibrant.webp": 4675,
	"./crobotp.webp": 77362,
	"./cse-deloitte.webp": 92789,
	"./datacorp.webp": 17013,
	"./delta-eee.webp": 28253,
	"./delta-eie.webp": 24465,
	"./delta-eie1.webp": 34252,
	"./eee-zoho.webp": 52287,
	"./ignitarium.webp": 97816,
	"./itc-eee.webp": 83525,
	"./jgc-eie.webp": 47067,
	"./kasadara.webp": 32859,
	"./mallowtech.webp": 32597,
	"./mrcooper.webp": 4072,
	"./nbase2syatem.webp": 66197,
	"./presidio.webp": 14442,
	"./rently.webp": 48273,
	"./valeo.webp": 21536,
	"./workhall.webp": 94311,
	"./zoho-eie.webp": 99315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71213;